import React from 'react'

import { Box, Typography } from "@mui/material"


export default function usersColumn() {

	return {
		name: 'user',
		label: 'User',
		options: {
			customBodyRowRenderLite: value => <Box>
				<Typography>{value}</Typography>
			</Box>
		},
	}
}